import { FormInstance } from '../../models/site-content/form-instance.model';
import { FormInstanceElement } from '../../models/form-builder/form-instance-element.model';
import { BehaviorSubject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { FormInstanceOperationsDialog } from './form-instance-operations.dialog';

// This file contains some helper classes used by the FormInstanceOperationsDialog:
// FormInstanceOperationsDialogInitInfo
// FormInstanceOperationsDialogManager
// FormInstanceOperationsDialogCloseInfo

// FormInstanceOperationsDialogManager provides methods for working with the three ways in which FormInstanceOperationsDialog is used
// - processFormOpenDialog()
// - processFormSaveDialog()
// - processFormTransition()
export class FormInstanceOperationsDialogManager {

    private static dialogRef: MatDialogRef<FormInstanceOperationsDialog, any>;

    public static processFormOpenDialog(id: number, aFormInstanceIsLoadingMessage: BehaviorSubject<string>, dialog: MatDialog) {
        let initInfo = new FormInstanceOperationsDialogInitInfo(FormInstanceOperationsDialogInitInfo.OPEN, null, null, null, null, id, aFormInstanceIsLoadingMessage);

        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '600px';
        dialogConfig.data = initInfo;

        this.dialogRef = dialog.open(FormInstanceOperationsDialog, dialogConfig);
        return this.dialogRef;
    }

    public static closeFormDialog() {
        if (this.dialogRef)
            this.dialogRef.close();
    }

    // Both this method and processFormTransition() are convenience mwthods that call processSave()
    public static processFormSaveDialog(formInstance: FormInstance, dirtyElements: FormInstanceElement[], dialog: MatDialog): MatDialogRef<FormInstanceOperationsDialog> {
        return FormInstanceOperationsDialogManager.processSave(FormInstanceOperationsDialogInitInfo.SAVE, formInstance, dirtyElements, null, null, dialog);
    }

    public static processFormTransition(formInstance: FormInstance, dirtyElements: FormInstanceElement[], dialog: MatDialog, transitionMessage: string = null, transitionTitle: string = null): MatDialogRef<FormInstanceOperationsDialog> {
        return FormInstanceOperationsDialogManager.processSave(FormInstanceOperationsDialogInitInfo.SAVE_WITH_TRANSITION, formInstance, dirtyElements, transitionMessage, transitionTitle, dialog);
    }

    private static processSave(operation: string, formInstance: FormInstance, dirtyElements: FormInstanceElement[], transitionMessage: string, transitionTitle: string, dialog: MatDialog) {
        let initInfo = new FormInstanceOperationsDialogInitInfo(operation, formInstance, dirtyElements, transitionMessage, transitionTitle, null, null);

        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '600px';
        dialogConfig.data = initInfo;

        const dialogRef = dialog.open(FormInstanceOperationsDialog, dialogConfig);
        return dialogRef;
    }
}

// FormInstanceOperationsDialogInitInfo is just a parameter object which conveys a bunch of information to FormInstanceOperationsDialog
// which govern how it functions.
export class FormInstanceOperationsDialogInitInfo {
    public static OPEN: string = "formOpen";
    public static CLOSE: string = "formClose";
    public static SAVE: string = "formSave";
    public static SAVE_WITH_TRANSITION: string = "formSaveWithTransition";
    public withTransition: boolean;
    public transitionMessage: string;
    public transitionTitle: string;
    public operation: string;
    public formInstanceId: number;
    public aFormInstanceIsLoadingMessage: BehaviorSubject<string>;

    private static dialogRef: MatDialogRef<FormInstanceOperationsDialog, any>;

    public constructor(
        operation: string,
        public formInstance: FormInstance,
        public dirtyElements: FormInstanceElement[],
        transitionMessage: string,
        transitionTitle: string,
        formInstanceId: number,
        aFormInstanceIsLoadingMessage: BehaviorSubject<string>) {
        this.operation = operation;
        this.transitionMessage = transitionMessage;
        this.transitionTitle = transitionTitle;
        this.withTransition = transitionMessage != null;
        this.formInstanceId = formInstanceId;
        this.aFormInstanceIsLoadingMessage = aFormInstanceIsLoadingMessage;
    }
}

export class FormInstanceOperationsDialogCloseInfo {
    public reloadAfterClose: boolean;
    public userNoLongerHasAccess: boolean;
}
